export default "__VITE_ASSET__fd6a55f7__"